import React from "react";
import { t } from "i18n/index";
import { useMarketingLang } from "i18n/useMarketingLang";
import "../css/HowItWorksSection.scss";
import { getChromeTranslations } from "../marketing/i18n/pages/chrome";

export type HowItWorksTheme = "green" | "amber" | "pink" | "purple";

export interface HowItWorksStep {
	name: string;
	text: string;
}

interface Props {
	theme?: HowItWorksTheme;
	tinted?: boolean;
	badge?: string;
	title: React.ReactNode;
	description?: string;
	steps: HowItWorksStep[];
	ctaText: string;
	ctaHref?: string;
	onCtaClick?: () => void;
}

const HowItWorksSection: React.FC<Props> = ({
	theme = "green",
	tinted = false,
	badge,
	title,
	description,
	steps,
	ctaText,
	ctaHref = "/register",
	onCtaClick,
}) => {
	// An explicitly passed `badge` always wins — only the default falls back to the visitor's
	// locale, resolved via `useMarketingLang()`/chrome translations the same way Footer.tsx does.
	const lang = useMarketingLang();
	const translations = getChromeTranslations(lang);
	const resolvedBadge = badge ?? t(translations, "featureChrome.howItWorksBadge", "It only takes minutes");

	return (
		<section className={`hr-how-it-works hiw--${theme}${tinted ? " hiw--tinted" : ""}`}>
			<div className="container__inner">
				<span className="hiw__badge">{resolvedBadge}</span>
				<h2>{title}</h2>
				{description && <p>{description}</p>}
				<div className="hr-how-it-works__steps" style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}>
					{steps.map((step, i) => (
						<div key={i} className="hr-step">
							<div className="hr-step__number">{String(i + 1)}</div>
							<h4>{step.name}</h4>
							<p>{step.text}</p>
						</div>
					))}
				</div>
				<div className="hr-how-it-works__cta">
					<a href={ctaHref} className="hiw__cta-btn" onClick={onCtaClick}>
						{ctaText}
					</a>
				</div>
			</div>
		</section>
	);
};

export default HowItWorksSection;
